

const optionsData = [
  { name: "Ne pas être notifié", id: "no" },
  { name: "Recevoir les notifications par email", id: "email" },
];

export { optionsData };
